import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCityBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M11.188 5.61a2.625 2.625 0 0 1 2.624-2.62h5.223a2.64 2.64 0 0 1 2.637 2.64v12.63a2.64 2.64 0 0 1-2.637 2.64h-3.172c-.264 0-.41-.328-.267-.55.364-.565.565-1.22.569-1.91v-5.316a2.97 2.97 0 0 0-1.145-2.296l-3.72-2.97a.3.3 0 0 1-.113-.235z"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m14.051 11.61-3.983-3.183a2.426 2.426 0 0 0-3.009.004L3.111 11.61a1.94 1.94 0 0 0-.783 1.55v5.273a2.6 2.6 0 0 0 2.6 2.577h2.889q.006 0 .006-.008V16.72a.75.75 0 0 1 1.5 0v4.282q0 .008.006.008h2.907c.683 0 1.326-.263 1.812-.742a2.58 2.58 0 0 0 .773-1.835v-5.292a1.98 1.98 0 0 0-.77-1.531"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.221 8.174a.75.75 0 0 0 .75-.75v-.011a.745.745 0 0 0-.75-.744.755.755 0 0 0-.75.755c0 .414.336.75.75.75M17.471 11.913c0 .414.336.744.75.744s.75-.341.75-.755a.75.75 0 0 0-1.5 0zM18.221 17.14a.75.75 0 0 0 .75-.75v-.01a.746.746 0 0 0-.75-.745.755.755 0 0 0-.75.756c0 .414.336.75.75.75M14.692 8.174a.75.75 0 0 0 .75-.75v-.011a.745.745 0 0 0-.75-.744.755.755 0 0 0-.75.755c0 .414.336.75.75.75"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCityBulk);
export default ForwardRef;
